import { FeatureFlagServiceProvider } from '../service/FeatureFlagServiceProvider';
import { FeatureFlagDirective } from '../directive/FeatureFlagDirective';
import * as angular from 'angular';
var FeatureFlagAngular1Module = /** @class */ (function () {
    function FeatureFlagAngular1Module() {
    }
    FeatureFlagAngular1Module.registerModule = function () {
        angular.module(this._moduleName, [])
            .provider('FeatureFlagService', FeatureFlagServiceProvider)
            .directive('featureFlag', ['FeatureFlagService', FeatureFlagDirective.featureFlag]);
    };
    Object.defineProperty(FeatureFlagAngular1Module, "FlightingNg1ModuleName", {
        get: function () {
            return this._moduleName;
        },
        enumerable: true,
        configurable: true
    });
    FeatureFlagAngular1Module._moduleName = "Microsoft.PS.Flighting";
    return FeatureFlagAngular1Module;
}());
export { FeatureFlagAngular1Module };
//# sourceMappingURL=FeatureFlagModule.js.map